import { z } from "zod";

export const OperatorSchema = z.enum([
  "EQUAL",
  "NOT_EQUAL",
  "LESS_THAN",
  "LESS_THAN_OR_EQUAL",
  "GREATER_THAN",
  "GREATER_THAN_OR_EQUAL",
  "EXISTS",
  "NOT_EXISTS",
  "IN",
  "NOT_IN",
  "NEAR",
  "CONTAINS",
  "NOT_CONTAINS",
  "FEATURES_CONTAINS",
  "FEATURES_NOT_CONTAINS",
]);

export type Operator = z.infer<typeof OperatorSchema>;

export type Conditional = "AND" | "OR";

export type Filter = {
  property: string;
  operator: Operator;
  value: string | number | boolean | null;
  id: string;
};

export type FilterGroup = {
  conditional: Conditional;
  expressions: Expression[];
};

export type Expression = Filter;

export type FilterQuery = {
  filterGroup: FilterGroup;
  search?: string;
};
